import {
  InputGroup,
  InputGroupInput,
  InputGroupAddon,
} from "@sendsprint/ui-react/shadcn/input-group";
import React, { ReactNode } from "react";
import SearchIcon from "@/assets/svgs/search.svg";

interface Props {
  value?: string;
  handleChange?: (
    e: React.ChangeEvent<HTMLInputElement, HTMLInputElement>,
  ) => void;
  placeholder?: string;
  rightAddon?: ReactNode;
}

const SearchInput = ({
  handleChange,
  value,
  placeholder = "Search...",
  rightAddon,
}: Props) => {
  return (
    <InputGroup className="ss:py-6 ss:px-3 ss:rounded-2xl">
      <InputGroupInput
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        type="search"
      />
      <InputGroupAddon>
        <SearchIcon />
      </InputGroupAddon>
      {rightAddon && (
        <InputGroupAddon align="inline-end">{rightAddon}</InputGroupAddon>
      )}
    </InputGroup>
  );
};

export default SearchInput;
